import { render, staticRenderFns } from "./SitesEdit.vue?vue&type=template&id=0fce50b8&"
import script from "./SitesEdit.vue?vue&type=script&lang=js&"
export * from "./SitesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fce50b8')) {
      api.createRecord('0fce50b8', component.options)
    } else {
      api.reload('0fce50b8', component.options)
    }
    module.hot.accept("./SitesEdit.vue?vue&type=template&id=0fce50b8&", function () {
      api.rerender('0fce50b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sites/SitesEdit.vue"
export default component.exports